import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { isEmptyOrNil } from 'core/helpers';

import '../bonus-selection.scss';
import { DepositBonus, DEFAULT_BONUS_OPTION } from './deposit-bonus/deposit-bonus';

const preloaderItems = [0, 1, 2];

export class BonusSelectionListViewUI extends Component {
  static propTypes = {
    bonuses: PropTypes.arrayOf(
      PropTypes.shape({
        label: '',
        value: '',
      })
    ).isRequired,
    currency: PropTypes.string.isRequired,
    depositBonuses: PropTypes.arrayOf(PropTypes.shape({})),
    bonusActive: PropTypes.string,
    isInProgress: PropTypes.bool.isRequired,
    updateModalAlignment: PropTypes.func,
    changeBonusHandler: PropTypes.func,
  };

  static defaultProps = {
    depositBonuses: null,
    bonusActive: '',
    updateModalAlignment: null,
    changeBonusHandler: () => {},
  };

  componentDidUpdate(prevProps) {
    const { isInProgress: prevIsInProgress } = prevProps;
    const { isInProgress, updateModalAlignment } = this.props;

    if (!isInProgress && prevIsInProgress) {
      if (updateModalAlignment) {
        updateModalAlignment();
      }
    }
  }

  defineCurrentBonus = (bonus) => {
    const { depositBonuses } = this.props;

    if (isEmptyOrNil(depositBonuses) || bonus === DEFAULT_BONUS_OPTION) {
      return null;
    }

    return R.find(R.propEq('bonusPlanId', bonus))(depositBonuses);
  };

  render() {
    const {
      bonuses,
      currency,
      isInProgress,
      bonusActive,
      changeBonusHandler
    } = this.props;

    return (
      <div className="w-100 bonus-selection-items rounded px-3">
        {isInProgress
          ? preloaderItems.map(id => (
            <div
              key={id}
              className="deposit-bonus-list-view deposit-bonus-list-view-preloader preloader rounded bg-white-4 mb-1 mr-1 flex-grow-1 w-100"
            />
          ))
          : bonuses.map(({
            value, label, disabled, min
          }) => (
            <DepositBonus
              currency={currency}
              key={value}
              isActive={value === bonusActive}
              bonusType={value}
              bonusLabel={label}
              disabled={disabled}
              minDepositAmount={min}
              handleClick={changeBonusHandler}
              currentBonus={this.defineCurrentBonus(value)}
            />
          ))}
      </div>
    );
  }
}

